export type ProblemBookmark = {
  id: number;
  title: string;
  addedAt: string;
};

const STORAGE_KEY = 'nn_problem_bookmarks';

function legacyBookmarkKey(problemId: number): string {
  return `nn_problem_bookmark_${problemId}`;
}

export function readProblemBookmarks(): ProblemBookmark[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as unknown;
      if (Array.isArray(parsed)) {
        return parsed
          .filter(
            (item): item is ProblemBookmark =>
              item != null &&
              typeof item === 'object' &&
              typeof (item as ProblemBookmark).id === 'number' &&
              typeof (item as ProblemBookmark).title === 'string'
          )
          .sort(
            (a, b) =>
              new Date(b.addedAt).getTime() - new Date(a.addedAt).getTime()
          );
      }
    }
  } catch {
    // ignore
  }
  return [];
}

function saveProblemBookmarks(list: ProblemBookmark[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // ignore
  }
}

export function isProblemBookmarked(problemId: number): boolean {
  return readProblemBookmarks().some((b) => b.id === problemId);
}

export function toggleProblemBookmark(problem: {
  id: number;
  title: string;
}): boolean {
  const list = readProblemBookmarks();
  const index = list.findIndex((b) => b.id === problem.id);

  if (index >= 0) {
    list.splice(index, 1);
    saveProblemBookmarks(list);
    try {
      localStorage.removeItem(legacyBookmarkKey(problem.id));
    } catch {
      // ignore
    }
    return false;
  }

  list.unshift({
    id: problem.id,
    title: problem.title,
    addedAt: new Date().toISOString(),
  });
  saveProblemBookmarks(list);
  try {
    localStorage.removeItem(legacyBookmarkKey(problem.id));
  } catch {
    // ignore
  }
  return true;
}

export function removeProblemBookmark(problemId: number): void {
  const list = readProblemBookmarks().filter((b) => b.id !== problemId);
  saveProblemBookmarks(list);
  try {
    localStorage.removeItem(legacyBookmarkKey(problemId));
  } catch {
    // ignore
  }
}

/** Перенос старых флагов `nn_problem_bookmark_<id>` в общий список. */
export function migrateLegacyBookmarkIfNeeded(problem: {
  id: number;
  title: string;
}): void {
  try {
    if (localStorage.getItem(legacyBookmarkKey(problem.id)) !== '1') return;
    const list = readProblemBookmarks();
    if (!list.some((b) => b.id === problem.id)) {
      list.unshift({
        id: problem.id,
        title: problem.title,
        addedAt: new Date().toISOString(),
      });
      saveProblemBookmarks(list);
    }
    localStorage.removeItem(legacyBookmarkKey(problem.id));
  } catch {
    // ignore
  }
}
